import AssetLoanApprovalTable from "./ApprovalTable";

const RegionAssetLoanApproval = () => <AssetLoanApprovalTable level="region" />;

export default RegionAssetLoanApproval;
